import Vue from "vue";
import App from "./App.vue";
import VueMoment from "vue-moment";
import Moment from "moment";
import MomentTimeZone from "moment-timezone";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import DataModule from "highcharts/modules/export-data";

Exporting(Highcharts);
window.moment = Moment;
MomentTimeZone();
DataModule(Highcharts);

Vue.use(HighchartsVue);

Vue.use(require("vue-moment"), {
  Moment
});

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "axios";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Firebase
import "@/firebase/firebaseConfig";

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n/i18n";

// Vuesax Admin Filters
import "./filters/filters";

//Vue bars

import Bars from "vuebars";

Vue.use(Bars);

//vue trends

import Trend from "vuetrend";

Vue.use(Trend);

//DateTime Picker

import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);
import VueMq from "vue-mq";
import fullscreen from "vue-fullscreen";

Vue.use(fullscreen);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity
  }
});
// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import SelectFilter from "./filters/SelectFilter.vue";
import TrendFilter from "./filters/TrendFilter.vue";
import DimmingFilter from "./filters/DimmingFilter.vue";
Vue.component("SelectFilter", SelectFilter);
Vue.component("TrendFilter", TrendFilter);
Vue.component("DimmingFilter", DimmingFilter);
//Google Map Cluster
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues

Vue.component("GmapCluster", GmapCluster);
// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: "AIzaSyD7I-CM6G3BPSZG_jp6YJA6ctpB2Ie5844", //AIzaSyD7I-CM6G3BPSZG_jp6YJA6ctpB2Ie5844
    libraries: "places" // This is required if you use the Auto complete plug-in
  }
});

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  acl,
  render: (h) => h(App)
}).$mount("#app");
